import { useAudioLevel } from '@utils/hooks/useAudioLevel';
import './PhoneState.scss';
import { PhoneStateParams } from './PhoneState.type';

export default function PhoneState(props: PhoneStateParams) {
  const { on = false, mode = 'small', outerLevel, ableOuterLevel, stream } = props;

  const audioLevel = useAudioLevel(stream, true, !ableOuterLevel);
  return (
    <span className={`phone-state phone-state--${mode}`}>
      {on ? (
        <i
          className={`phone-state__mic-icon phone-state__mic-icon--level${ableOuterLevel ? outerLevel : audioLevel}`}
        />
      ) : (
        <i className="phone-state__mic-icon phone-state__mic-icon--off" />
      )}
    </span>
  );
}
